import React from 'react'
import * as Styled from './styled'

interface FullWidthBannerProps {
  title: string
  subtitle?: string
  backgroundColour: string
  minHeight?: string
}

export const FullWidthBanner: React.FC<FullWidthBannerProps> = ({
  title,
  subtitle,
  backgroundColour,
  minHeight,
}) => {
  return (
    <>
      <Styled.FullWidthBanner backgroundColour={backgroundColour} minHeight={minHeight}>
        <Styled.BoldText>{title}</Styled.BoldText>
        {subtitle}
      </Styled.FullWidthBanner>
    </>
  )
}
